import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './App.css';
import PublicOnlyRoute from "./components/PublicOnlyRoute";
import PrivateRoute from "./components/PrivateRoute";
import Layout from "./components/Layout";
import Login from './pages/Login';
import AutoLogin from "./components/AutoLogin";
import Dashboard from "./pages/Dashboard";
import Inventory from "./pages/Inventory";
import Stockin from "./pages/Stockin";
import Checkout from "./pages/Checkout";
import Print from "./pages/Print";
import Printerset from "./pages/Printerset";
import Shortcut from "./pages/AdminShortcuts";
import ProductLogsPage from "./pages/ProductLogsPage";
import ProjectListPage from "./pages/ProjectListPage";
import ProjectDetailPage from "./pages/ProjectDetailPage";
import Board from "./pages/Board";

function App() {
  return (
    <Router>
      <AutoLogin /> 
      <Routes>
        {/* 로그인 페이지 */}
        <Route
          path="/login"
          element={
            <PublicOnlyRoute>
              <Login />
            </PublicOnlyRoute>
          }
        />

        {/* Layout을 유지하면서 인증이 필요한 페이지 */}
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/inventory" element={<Inventory />} />
          <Route path="/stockin" element={<Stockin />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/print" element={<Print />} />
          <Route path="/printerset" element={<Printerset />} />
          <Route path="/shortcut" element={<Shortcut />} />
          <Route path="/logs" element={<ProductLogsPage />} />
          <Route path="/logs/:productId" element={<ProductLogsPage />} />
          <Route path="/projects" element={<ProjectListPage />} />
          <Route path="/projects/:id" element={<ProjectDetailPage />} />
          <Route path="/board" element={<Board />} />
        </Route>

        {/* 잘못된 경로는 로그인 페이지로 이동 */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
